import { Check } from "lucide-react";
import VideoEmbed from "@/components/app/VideoEmbed";
import { useOverride } from "@/context/ContentContext";

/** Full-screen required education module: video (admin-managed) + long-form text + mark-as-viewed gate. */
export default function EducationModule({ number, total, title, subtitle, body, onContinue, viewed, onMarkViewed, testidBase, moduleKey }) {
  const videoUrl = useOverride("education_module", moduleKey, "video_url", "");
  const oTitle = useOverride("education_module", moduleKey, "title", title);
  const oSubtitle = useOverride("education_module", moduleKey, "subtitle", subtitle);
  const oBody = useOverride("education_module", moduleKey, "body", body);
  return (
    <div className="bg-warm-white border border-edge rounded-3xl p-8 md:p-12" data-testid={`${testidBase}`}>
      <div className="text-xs uppercase tracking-widest text-mauve font-semibold">Required · Module {number} of {total}</div>
      <h1 className="font-display text-3xl font-bold text-navy mt-1">{oTitle}</h1>
      {oSubtitle && <p className="text-ink-mid mt-2">{oSubtitle}</p>}

      <div className="mt-6" data-testid={`${testidBase}-video`}>
        <VideoEmbed value={videoUrl} title={`Module ${number} — ${oTitle}`} placeholder={`Module ${number} — ${oTitle}`} testid={`${testidBase}-video`} />
      </div>

      <div className="mt-6 space-y-4 text-ink-dark leading-relaxed whitespace-pre-line" data-testid={`${testidBase}-body`}>
        {oBody}
      </div>

      <div className="mt-8 flex items-center justify-between flex-wrap gap-3">
        <button data-testid={`${testidBase}-mark`} onClick={onMarkViewed} className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold border transition ${viewed ? "border-gold bg-cream text-navy" : "border-edge text-ink-mid hover:border-gold hover:text-navy"}`}>
          {viewed ? <><Check size={14} className="text-gold" /> Marked as viewed</> : "Mark as viewed"}
        </button>
        <button data-testid={`${testidBase}-continue`} onClick={onContinue} disabled={!viewed} className="bg-gold text-ink-dark px-6 py-3 rounded-full font-semibold hover:bg-gold-light disabled:opacity-40 disabled:cursor-not-allowed">
          Continue
        </button>
      </div>
    </div>
  );
}
